<template>

    <div>

        <form v-if="dataStore.formPopUpReady" v-on:submit.prevent="submitForm" :data-question="dataStore?.currentOpinion?.question?.id">

            <ul style="padding-left: 20px;" v-if="dataStore.errors.length">
                <li v-for="(err,i) in dataStore.errors" :key="i">{{ err }}</li>
            </ul>

            <span class="close-popup" @click="closeInfo($event)"><i class="fas fa-times"></i></span>

            <legend :class="{ 'both-good-bad' : bothGoodAndBad }">{{ legend }}</legend>

            <div v-if="bothGoodAndBad" class="form-group first">

                <input
                    type="radio"
                    id="good"
                    value="good"
                    v-if="slide.allow_good_options"
                    v-model="dataStore.currentOpinion.value_type"
                    @change="resetOnRadioChange"
                >

                <label v-if="slide.allow_good_options" for="good">{{ slide.good_label !== null ? slide.good_label : language.good }}</label>

                <input
                    type="radio"
                    id="bad"
                    v-if="slide.allow_bad_options"
                    v-model="dataStore.currentOpinion.value_type"
                    value="bad"
                    @change="resetOnRadioChange"
                >

                <label v-if="slide.allow_bad_options" for="bad">{{ slide.bad_label !== null ? slide.bad_label : language.improve }}</label>

            </div>

            <input v-else type="hidden" v-model="dataStore.currentOpinion.value_type" />

            <div v-if="(dataStore.currentOpinion && (dataStore.currentOpinion.value_type === 'good' || dataStore.currentOpinion.value_type === 'bad') && filtredSelectOptions.length ) && dontAllowDropdownOptions(parentslug)" class="form-group middle">

                <multiselect
                    v-model="dataStore.currentOpinion.values"
                    :value="dataStore.currentOpinion.values"
                    :options="filtredSelectOptions"
                    :multiple="true"
                    :close-on-select="true"
                    :clear-on-select="false"
                    track-by="val"
                    label="val"
                    :deselectLabel="language.click_to_remove"
                    :max-height="160"
                    :selectLabel="language.click_to_select"
                    :selectedLabel="language.selected"
                    :placeholder="language.select_qualities"
                ></multiselect>

            </div>

            <remove-image-toggle v-if="slide.question.allow_upload_image"></remove-image-toggle>

            <div class="form-group last">

                <textarea
                    class="form-control"
                    :placeholder="language.placeholder"
                    :Value="dataStore.currentOpinion.comment"
                    v-model="dataStore.currentOpinion.comment"
                    id="textarea"
                    rows="3"
                ></textarea>

                <add-image-toggle :slideid="slide.id" v-if="slide.question.allow_upload_image"></add-image-toggle>

            </div>

            <div class="container" v-if="!dataStore.addToExistingWindow">

                <div class="row continue-buttons-row">

                    <!-- not last  -->
                    <button :title="language.next" v-if="!dataStore.allowToChange && (dataStore.project.items.length !== (index + 1))" class="btn btn-primary last-form-button special">{{ language.next }}</button>
                    <!-- is last  -->
                    <button :title="language.next" v-if="!dataStore.allowToChange && (dataStore.project.items.length === (index + 1))" class="btn btn-primary last-form-button special" v-on:click.prevent="showLastPartForm">{{ language.next }}</button>

                    <button :title="language.add_more" v-if="( ( !  dataStore.allowToChange && ! hasLimit ) || ( ! dataStore.allowToChange && ( hasLimit && ( itemAnswersInBag < limit ) ) )  )" class="btn btn-secondary last-form-button" v-on:click.prevent="addToCollection($event)">{{ language.add_more }}</button>

                    <button :title="language.save_change " v-if="dataStore.allowToChange" class="btn btn-primary last-form-button" v-on:click.prevent="updateValueInCollection">{{ language.save_change }}</button>

                    <button :title="language.remove" v-if="dataStore.allowToChange" class="btn btn-secondary last-form-button" v-on:click.prevent="removeFromCollection">{{ language.remove }}</button>

                    <a :title="language.done_submit" href="#" class="go-to-last-link" v-on:click.prevent="showLastPartForm">{{ language.done_submit }}</a>

                </div>

            </div>

            <!-- when view comments / markers and adding on an existing  -->
            <div class="container" v-if="dataStore.addToExistingWindow">
                <div class="row continue-buttons-row">
                    <button :title="language.submit" class="btn btn-primary" v-on:click.prevent="addToExisting($event)">{{ language.submit }}</button>
                </div>
            </div>

        </form>

    </div>

</template>

<script>

import Multiselect from "vue-multiselect"
import { Fragment } from 'vue-fragment'
import dataStore from "../../store"
import AddImageToggle from './../image/AddImageToggle'
import RemoveImageToggle from './../image/RemoveImageToggle'

import { removeMarkerIfEmpty, dontAllowDropdownOptions, allowedLabelsProject, updateAnswer, removeMarker } from './../../functions'

export default {

    components: {
        Multiselect,
        Fragment,
        AddImageToggle,
        RemoveImageToggle
    },

    inject: [ 'language' ],

    data() {
        return {
            dataStore,
            allowSubmit : true,
            dontAllowDropdownOptions
        };
    },

    props: {
        index : Number,
        slide: Object,
        parentslug: String,
    },

    computed: {

        itemAnswersInBag: function() {
            return this.dataStore.collectedAnswers.filter(item => item.item_id === this.slide.id).length
        },

        limit: function() {
            return this.slide.amount_of_answers
        },

        hasLimit: function() {

            if(this.slide && this.slide.question) {
                return Boolean(this.slide.question.limit_markers)
            }

            return false
        },

        legend: function() {

            if( this.slide.custom_label ) {
                return this.slide.custom_label
            }

            else if( this.bothGoodAndBad ) {
                return this.language.form_popup_good_bad
            }

            else if( this.slide.allow_bad_options && ! this.slide.allow_good_options ) {
                return this.language.form_popup_bad
            }

            else if( !this.slide.allow_bad_options && this.slide.allow_good_options ) {
                return this.language.form_popup_good
            }

            else {
                return ''
            }
                 
        },

        bothGoodAndBad: function() {
            return this.slide.allow_bad_options && this.slide.allow_good_options
        },

        filtredSelectOptions: function() {
            return this.getOptions(this.slide.question.options, this.dataStore.currentOpinion.value_type);
        },

        errorText: function() {

            if( allowedLabelsProject(this.parentslug) ) {
                return 'Välj Bra/Mindre bra';
            }

            else {
                let badOption = this.slide.bad_label !== null ? this.slide.bad_label : this.language.improve
                return this.language.error_qualities.replacePlaceholders({ bad : badOption })
            }
        }
    },

    methods: {

        addToExisting: function(e) {

            this.errorHandling();

            if(this.allowSubmit) {

                this.dataStore.showLastPartForm = true

                this.$emit('close-popup')
            }
        },

        getOptions: function(values, radioValue) {

            return values.filter((obj) => {
                return obj.type === radioValue;
            })
            .map((obj) => {
                return {
                    id : obj.id,
                    type : obj.type,
                    val : obj.value
                }
            });

        },

        errorHandling: function() {

            if(this.slide.allow_bad_options || this.slide.allow_good_options) {

                this.allowSubmit = false;

                if(this.dataStore.currentOpinion.value_type === '' || this.dataStore.currentOpinion.value_type === null) {

                    if(!this.dataStore.errors.includes(this.errorText)) {
                        this.dataStore.errors.push(this.errorText)
                    }
                    
                }

                else if(allowedLabelsProject(this.parentslug) && this.dataStore.currentOpinion.value_type != '') {
                    this.allowSubmit = true;
                }

                else {

                    this.allowSubmit = true;

                    if( (this.dataStore.currentOpinion.values.length < 1 || this.dataStore.currentOpinion.value_type  === null ) && this.filtredSelectOptions.length > 0 ) {
                        
                        this.allowSubmit = false;

                        if(!this.dataStore.errors.includes(this.language.error_qualities_atleast)) {
                            this.dataStore.errors.push(this.language.error_qualities_atleast)
                        }

                    }

                }
            }
        },

        submitForm: function(e) {

            e.stopPropagation()

            this.errorHandling();

            if( this.allowSubmit ) {

                this.dataStore.formPopUpReady = false;

                this.addToCollection(e);

                this.dataStore.infoWinOpen = false;

                this.dataStore.sliderObject.next()
            }
        },

        addToCollection: function(e) {

            e.stopPropagation()

            this.errorHandling()

            if( this.allowSubmit ) {

                let answer = {
                    comment : this.dataStore.currentOpinion.comment,
                    values : this.dataStore.currentOpinion.values,
                    question : this.slide.question,
                    value_type : this.dataStore.currentOpinion.value_type,
                    created : true
                }

                this.dataStore.formPopUpReady = false;

                updateAnswer(answer, this.dataStore.currentOpinion.id)

                this.getFormValuesOrReset()

                this.$emit('close-popup')

            }

        },

        updateValueInCollection: function() {

            let answer = {
                comment : this.dataStore.currentOpinion.comment,
                values : this.dataStore.currentOpinion.values,
                question : this.slide.question,
                value_type : this.dataStore.currentOpinion.value_type,
                created : true
                // image : this.dataStore.currentOpinion.image
            }

            this.errorHandling();

            if( this.allowSubmit ) {

                this.dataStore.formPopUpReady = false;

                updateAnswer(answer, this.dataStore.currentOpinion.id);

                this.getFormValuesOrReset();

                this.$emit('close-popup')
            }
        },

        showLastPartForm: function() {

            this.errorHandling();

            if( this.allowSubmit ) {

                this.dataStore.formPopUpReady = false

                this.dataStore.infoWinOpen = false

                this.dataStore.showLastPartForm = true

                if( this.dataStore.collectedAnswers.length > 0 ) {

                    const foundIndex = this.dataStore.collectedAnswers.length - 1
    
                    const item = this.dataStore.collectedAnswers[ foundIndex ]
    
                    this.dataStore.collectedAnswers[ foundIndex ] = Object.assign(item, {
                        created : true
                    });

                }

                this.$emit('close-popup')

            }
        },

        removeFromCollection: function() {

            this.dataStore.infoWinOpen = !this.dataStore.infoWinOpen

            removeMarker(this.dataStore.currentOpinion)

        },

        getFormValuesOrReset: function() {

            this.dataStore.infoWinOpen = !this.dataStore.infoWinOpen

            this.dataStore.errors = []

        },

        closeInfo: function(e) {

            this.dataStore.infoWinOpen = false

            this.dataStore.formPopUpReady = false

            removeMarkerIfEmpty(this.dataStore.currentOpinion)

            this.dataStore.showReportWindow = false

            this.dataStore.addToExistingWindow = false

            this.$emit('close-popup')

            document.body.classList.remove('comment-window-open', 'report')

        },

        resetOnRadioChange: function(e) {

            this.dataStore.errors = [];

            this.dataStore.currentOpinion.value_type = e.target.value;

            this.dataStore.currentOpinion.values = [];
        }

    }
}

</script>

